module.exports = __webpack_public_path__ + "img/官网-V1_09.3c530fd9.png";